export enum AUTHORIZATION_TYPE {
  BASIC = '',
  BEARER = 'Bearer',
}
export type AuthorizationType = AUTHORIZATION_TYPE;
